import React, { useEffect, useState } from 'react';
import './_addvenue.css';
import { IAddVenueProps } from './IAddVenueProps';
import LabelledInput from '../LabelledInput';
import PrimaryButton from '../PrimaryButton';
import { VenueDrawPlot } from '../VenueDrawPlot/VenueDrawPlot';
import SecondaryButton from '../SecondaryButton';
import { ApiHandler } from '../../services/apiHandler';
import Spinner from '../Spinner';
import WarningAlert from '../WarningAlert';
import SuccessAlert from '../SuccessAlert';
import ErrorAlert from '../ErrorAlert';
import ConfirmAlert from '../confirmAlert';
import { useNavigate } from 'react-router-dom';
import { Dropdown, MenuProps, Upload, UploadProps } from 'antd';
import { CloseOutlined, DeleteTwoTone, DeploymentUnitOutlined, DownOutlined, FileImageOutlined, GlobalOutlined } from '@ant-design/icons';
import Dragger from 'antd/es/upload/Dragger';
import { Building } from '../../custom_icons/Building';
import ImageResizer from 'react-image-file-resizer';
import { PenIcon } from '../../custom_icons/PenTool';
import LabelLessInput from '../LabelLessInput';
import { availableCountries } from '../../constants/countryList';
import LabelledInputNew from '../LabelledInputNew';

export const AddVenue: React.FC<IAddVenueProps> = (props) => {
  let navigate = useNavigate();
  const [confirmAlert, setConfirmAlert] = useState({ alert: false, message: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    message: '',
    alert: false,
  });
  const [warning, setWarning] = useState({
    message: '',
    alert: false,
  });
  const [success, setSuccess] = useState({
    message: '',
    alert: false,
  });
  const [venue, setVenue] = useState({
    name: '',
    description: '',
    address: '',
    city: '',
    state: '',
    country: '',
    zipcode: '',
    latitude: 0,
    longitude: 0,
    address_2: '',
    image: '',
  });
  const [isDrawActive, setIsDrawActive] = useState(false);
  const [isCreateActive, setIsCreateActive] = useState(false);
  const [assetsInVenue, setAssetsInVenue] = useState<any[]>([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [imageUploaded, setImageUploaded] = useState(false);
  const [disableCreate, setDisableCreate] = useState(false);
  const [boundaryConfirmed, setBoundaryConfirmed] = useState(false);

  useEffect(() => {
    setVenue((prevValues: any) => {
      return {
        ...prevValues,
        latitude: parseFloat(props.position.lat.toFixed(6)),
        longitude: parseFloat(props.position.lng.toFixed(6)),
      };
    });
    if (props.venuesOnMap.length > 0 && props.position) {
      props.venuesOnMap?.map((venue: any) => {
        const contains: any = window.google.maps.geometry.poly.containsLocation(
          new window.google.maps.LatLng(props.position.lat, props.position.lng),
          new window.google.maps.Polygon({ paths: venue.polygon?.map((point: any) => new window.google.maps.LatLng(point.lat, point.lng)) })
        );
        if (contains) {
          setError({
            message: 'Venue cannot be created inside an existing venue boundary.',
            alert: true,
          });
          setDisableCreate(true);
        } else setDisableCreate(false);
      });
    }
    if (props?.position) reverseGeoCodeAddress();
  }, [props.position, props.venuesOnMap]);

  useEffect(() => {
    if (isCreateActive) {
      checkAssetsInVenue();
    }
  }, [props.assetsInBounds]);

  const handleInputChange = (e: any) => {
    setVenue((prevValues: any) => {
      return { ...prevValues, [e.target.name]: e.target.value };
    });
  };

  const drawBoundary = () => {
    setIsDrawActive(true);
    props.setBoundaryDrawMode('draw');
  };

  const confirmBoundary = () => {
    if (props.boundaryPolygon?.length === 0 || props.boundaryPolygon?.length === undefined) {
      setWarning({
        message: "Boundary of the venue is not defined yet. Click on the 'Draw Boundary Plot' button to start.",
        alert: true,
      });
      return;
    }
    setBoundaryConfirmed(true);
    setIsDrawActive(false);
    props.setBoundaryDrawMode(null);
  };

  const cancelBoundary = () => {
    setIsDrawActive(false);
    props.cancelBoundaryDraw();
  };

  const setBoundaryPolygonToCreateVenue = () => {
    // set boundary plot from google.maps.LatLng to {lat: number, lng: number}
    let boundary = props.boundaryPolygon?.map((point) => {
      return {
        lat: parseFloat(point.lat().toFixed(6)),
        lng: parseFloat(point.lng().toFixed(6)),
      };
    });

    // push first vertex as last vertex to make it a closed polygon
    boundary?.push(boundary[0]);
    return boundary;
  };

  const checkAssetsInVenue = () => {
    if (props.assetsInBounds.length > 0) {
      let assetsInVenueList: any[] = [];
      for (let asset of props.assetsInBounds) {
        const contains: any = window.google.maps.geometry.poly.containsLocation(
          new window.google.maps.LatLng(asset.latitude, asset.longitude),
          new window.google.maps.Polygon({ paths: props.boundaryPolygon })
        );
        if (contains) {
          assetsInVenueList.push(asset);
        }
      }
      setAssetsInVenue(assetsInVenueList);
      if (assetsInVenueList.length > 0) {
        let confirmMessage: string = '<b>Assets with following Site IDs fall inside the bounds of venue.</b><br/><br/><ul>';
        assetsInVenueList.forEach((asset: any) => {
          confirmMessage += '<li>' + asset.tracking_id + '</li>';
        });
        confirmMessage +=
          '</ul><i>On confirming the creation, the assets will <b>automatically be associated to the venue</b>.</i><br/><br/><span>Do you want to proceed?</span>';
        setConfirmAlert({ alert: true, message: confirmMessage });
      }
    }
    setIsCreateActive(false);
  };

  const validateRequest = () => {
    if (venue.name.trim() === '') {
      setWarning({ message: 'Venue name is required', alert: true });
      return false;
    } else if (venue.city && /\d/.test(venue.city)) {
      setWarning({ message: 'Please enter a valid city name', alert: true });
      return false;
    } else if (venue.state && /\d/.test(venue.state)) {
      setWarning({ message: 'Please enter a valid state name', alert: true });
      return false;
    } else if (venue.zipcode && /\D/.test(venue.zipcode)) {
      setWarning({ message: 'Please enter a valid zip code', alert: true });
      return false;
    }
    return true;
  };

  /* 
  Create Venue API call after confirmation
*/
  const createVenueAPI = () => {
    if (!validateRequest()) return;
    setLoading(true);
    let boundary = setBoundaryPolygonToCreateVenue();
    // create the request json
    const requestBody = {
      ...venue,
      boundary_plot: boundary,
      country: venue.country ?? selectedCountry ?? null,
    };
    console.log(requestBody, 'requestBody');
    ApiHandler({ apiName: 'createVenue', body: requestBody, params: {} })
      .then((response: any) => {
        setLoading(false);
        setSuccess({
          message: 'Venue created successfully',
          alert: true,
        });
        if (assetsInVenue.length > 0) {
          addAssetsToVenue(response.data.venue_id);
        } else {
          props.cancelBoundaryDraw();
          props.setCurrentVenueId(response.data.venue_id);
          setTimeout(() => {
            props.navigateTo('venueDetails');
          }, 2000);
        }
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
          setIsCreateActive(false);
        }
      });
  };

  const startCreateVenue = () => {
    if (props.boundaryPolygon?.length === 0 || props.boundaryPolygon?.length === undefined) {
      setWarning({
        message: "Boundary of the venue is not defined yet. Click on the 'Draw Boundary Plot' button to start.",
        alert: true,
      });
      return;
    }
    if (!boundaryConfirmed) {
      setWarning({
        message: 'Please confirm the venue boundary before creating the venue.',
        alert: true,
      });
      return;
    }
    setIsCreateActive(true);
    setConfirmAlert({ alert: true, message: 'Are you sure you want to finalize the venue creation?' });
    props.fitVenueOnMap();
  };

  const addAssetsToVenue = (venueId: any) => {
    setLoading(true);

    const requestBody: any = { asset_ids: [], venue_id: venueId };
    assetsInVenue.forEach((asset: any) => {
      requestBody.asset_ids.push(asset.id);
    });
    ApiHandler({ apiName: 'addAssetsToVenue', body: requestBody, params: {} })
      .then((response: any) => {
        setLoading(false);
        setSuccess({
          message: 'Assets added to the venue successfully',
          alert: true,
        });

        props.cancelBoundaryDraw();
        props.setCurrentVenueId(venueId);
        setTimeout(() => {
          props.navigateTo('venueDetails');
        }, 1000);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
          setIsCreateActive(false);
        }
      });
  };

  const items: MenuProps['items'] = [
    {
      key: 'venue',
      label: 'Venue',
      icon: <GlobalOutlined />,
    },
    {
      key: 'market',
      label: 'Market',
      icon: <DeploymentUnitOutlined />,
    },
    {
      key: 'building',
      label: 'Building',
      icon: <Building />,
    },
  ];

  const propsDragger: UploadProps = {
    name: 'file',
    multiple: false,
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
    accept: 'image/png, image/jpeg',

    beforeUpload: (file) => {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isImage) {
        setWarning({ message: 'You can only upload JPG/PNG file!', alert: true });
        return Upload.LIST_IGNORE;
      }

      const isLt4M = file.size / 1024 / 1024 < 4;
      if (!isLt4M) {
        setWarning({ message: 'Image must be smaller than 4MB!', alert: true });
        return Upload.LIST_IGNORE;
      }
      ImageResizer.imageFileResizer(
        file,
        800,
        800,
        'JPEG',
        100,
        0,
        (uri: any) => {
          setImageUploaded(true);
          setVenue((prev) => ({ ...prev, image: uri }));
        },
        'base64'
      );

      return false;
    },
  };

  const reverseGeoCodeAddress = () => {
    setLoading(true);
    ApiHandler({ apiName: 'getAddress', body: {}, params: {}, queryParams: { latitude: props.position.lat, longitude: props.position.lng } })
      .then((res: any) => {
        setLoading(false);
        if (res?.data?.address)
          setVenue((prevValues: any) => {
            return { ...prevValues, ['address']: res.data.address };
          });
        if (res?.data?.country)
          setVenue((prevValues: any) => {
            return { ...prevValues, ['country']: res.data.country };
          });
        if (res?.data?.state)
          setVenue((prevValues: any) => {
            return { ...prevValues, ['state']: res.data.state };
          });
        if (res?.data?.city)
          setVenue((prevValues: any) => {
            return { ...prevValues, ['city']: res.data.city };
          });
        if (res?.data?.zipcode)
          setVenue((prevValues: any) => {
            return { ...prevValues, ['zipcode']: res.data.zipcode };
          });
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.doLogout === true) {
          setError({ message: 'Session Timed Out', alert: true });
          setTimeout(() => navigate('/login', { replace: true }), 2000);
        } else {
          setError({ message: error.data.message, alert: true });
        }
      });
  };

  return (
    <div className="h-100 row-wise overflow-auto">
      <div className="right row-wise">
        {/* Plot Boundary */}

        {isDrawActive && <VenueDrawPlot setColor={() => {}} color={''} />}

        <div className="app-card position-relative app-card-size ">
          {/* <div className="row-wise vertical-center">
            <div
              className="icon-background-active"
              onClick={() => {
                cancelBoundary();
                props.navigateTo("home");
              }}
            >
              <span className="material-icons-round icon-active">arrow_back</span>
            </div>

            <span className="app-card-action-heading ms-3">ADDING VENUE</span>
          </div> */}

          <div className="row-wise vertical-center space-between px-4 py-2">
            <span className="app-card-action-heading fw-bold">New Venue</span>
            <div
              onClick={() => {
                cancelBoundary();
                props.navigateTo('home');
              }}>
              <CloseOutlined className="fs-6" />
            </div>
          </div>
          <div className="border-bottom" />
          <div className="overflow-auto">
            <div className="px-4 py-2">
              {/* <div className="pt-1">
                <Dropdown className="w-100" disabled menu={{ items }} trigger={['click']}>
                  <div className="border row-wise space-between vertical-center background-white" onClick={(e) => e.preventDefault()}>
                    <span>
                      {' '}
                      <GlobalOutlined /> &nbsp; Venue
                    </span>
                    <DownOutlined />
                  </div>
                </Dropdown>
              </div> */}
              {imageUploaded ? (
                <div className="vertical-center center my-3 position-relative">
                  <DeleteTwoTone
                    className="position-absolute z-index-10"
                    onClick={() => {
                      const venueTemp = venue;
                      venueTemp['image'] = '';
                      setVenue(venueTemp);
                      setImageUploaded(false);
                    }}
                  />
                  <img src={venue.image} height={'auto'} width={350 - 48} />
                </div>
              ) : (
                <div className="drop-height">
                  <Dragger {...propsDragger}>
                    <p className="ant-upload-drag-icon">
                      <FileImageOutlined />
                    </p>
                    <p className="ant-upload-text upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint upload-text-sub">Pick a photo up to 4MB.</p>
                  </Dragger>
                </div>
              )}
            </div>
            <div className="border-bottom mx-4" />
            <div className="px-4 py-2">
              <div className="fw-semibold small text-muted mb-2 mt-2">Venue Boundaries</div>

              {isDrawActive ? (
                <div className="row gx-2 ">
                  <div className="col-6">
                    <SecondaryButton className="my-2 h-btn-lg" label={'Confirm Boundary'} clicked={confirmBoundary} disable={false} />
                  </div>
                  <div className="col-6">
                    <SecondaryButton className="my-2 h-btn-lg" label={'Cancel'} clicked={cancelBoundary} disable={false} type="delete" />
                  </div>
                </div>
              ) : (
                <div className="w-100">
                  <SecondaryButton
                    className="mb-2 mt-2"
                    label={'Draw boundaries'}
                    clicked={drawBoundary}
                    disable={false}
                    icon={<PenIcon style={{ color: '#1677FF' }} />}
                  />
                </div>
              )}

              <form className="col-wise h-100 pb-1 mb-1 pt-2">
                <LabelledInputNew
                  title="Name *"
                  name="name"
                  onChange={(e: any) => {
                    handleInputChange(e);
                  }}
                  value={venue.name}
                  placeholder="Enter name"
                  titleClassName="fw-semibold small text-muted"
                  textColorRequired={false}
                />
                <LabelledInputNew
                  title="Description"
                  name="description"
                  onChange={(e: any) => {
                    handleInputChange(e);
                  }}
                  value={venue.description}
                  placeholder="Enter description"
                  titleClassName="fw-semibold small text-muted"
                  textColorRequired={false}
                />

                <div className="row g-2 mb-3 mt-2">
                  <div className="col-6">
                    <div className="rounded p-2" style={{ backgroundColor: '#e4f1f4' }}>
                      <span className="d-block mb-1 fw-semibold small text-muted">Latitude</span>
                      <span className="d-block fw-bold text-dark">{venue.latitude.toFixed(6)}</span>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="rounded p-2" style={{ backgroundColor: '#e4f1f4' }}>
                      <span className="d-block mb-1 fw-semibold small text-muted">Longitude</span>
                      <span className="d-block fw-bold text-dark">{venue.longitude.toFixed(6)}</span>
                    </div>
                  </div>
                </div>

                <LabelledInputNew
                  title="Street Address"
                  value={venue.address}
                  placeholder="Enter Street Address"
                  name="address"
                  onChange={(e: any) => handleInputChange(e)}
                  titleClassName="fw-semibold small text-muted"
                  textColorRequired={false}
                />

                <div className="row gx-2">
                  <div className="col-6">
                    <LabelledInputNew
                      title="City"
                      name="city"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={venue.city}
                      placeholder="Enter City"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                  <div className="col-6">
                    <LabelledInputNew
                      title="State"
                      name="state"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={venue.state}
                      placeholder="Enter State"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                </div>
                <div className="row gx-2">
                  <div className="col-6">
                    <div className="mb-2">
                      <span className="d-block mb-2 fw-semibold small text-muted">Country</span>
                      <div className="dropdown">
                        <button className="w-100" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                          {selectedCountry ? selectedCountry : venue?.country ? venue.country : 'Select'}
                        </button>

                        <ul className="dropdown-menu w-100">
                          {availableCountries.map((country: any) => {
                            return (
                              <li key={country?.id}>
                                <span
                                  onClick={() => {
                                    setSelectedCountry(country.name);
                                    setVenue((prevValues: any) => {
                                      return { ...prevValues, country: country.name };
                                    });
                                  }}
                                  className="dropdown-item">
                                  {country.name}
                                </span>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <LabelledInputNew
                      title="Zip Code"
                      name="zipcode"
                      onChange={(e: any) => {
                        handleInputChange(e);
                      }}
                      value={venue.zipcode}
                      placeholder="Enter ZIP"
                      titleClassName="fw-semibold small text-muted"
                      textColorRequired={false}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div style={{ marginTop: 'auto' }} className="row-wise vertical-center px-4 py-2 gap-3">
            <SecondaryButton
              className="w-100"
              label={'Cancel'}
              clicked={() => {
                cancelBoundary();
                props.navigateTo('home');
              }}
              disable={false}
            />
            <PrimaryButton
              className="w-100 blue-bg"
              label="Save"
              clicked={() => {
                startCreateVenue();
              }}
              disable={disableCreate}
            />
          </div>
        </div>

        <Spinner show={loading} />

        <ConfirmAlert
          message={confirmAlert.message}
          primaryText={'Yes'}
          secondaryText={'No'}
          secondaryAction={() => {
            setConfirmAlert({ alert: false, message: '' });
            setAssetsInVenue([]);
          }}
          visible={confirmAlert.alert}
          title={` Finish Venue Creation `}
          primaryAction={() => {
            setConfirmAlert({ alert: false, message: '' });
            createVenueAPI();
          }}
          onClose={() => {
            setConfirmAlert({ alert: false, message: '' });
            setAssetsInVenue([]);
          }}
        />

        <ErrorAlert
          show={error.alert}
          onDismiss={() => {
            setError({ message: '', alert: false });
          }}
          message={error.message}
        />
        <SuccessAlert
          show={success.alert}
          onDismiss={() => {
            setSuccess({ message: '', alert: false });
          }}
          message={success.message}
        />
        <WarningAlert
          show={warning.alert}
          onDismiss={() => {
            setWarning({ message: '', alert: false });
          }}
          message={warning.message}
        />
      </div>
    </div>
  );
};
